import * as CONST from "./actionTypes";

export const addSignature = (payload, callBack) => {
  return {
    type: CONST.ADD_SIGNATURE,
    payload: { ...payload },
    callBack,
  };
};

export const addSignature_Success = (payload) => ({
  type: CONST.ADD_SIGNATURE_SUCCESS,
  payload,
});

export const addSignature_Fail = (payload) => ({
  type: CONST.ADD_SIGNATURE_FAIL,
  payload,
});

export const getSignature = (payload, callBack) => {
  return {
    type: CONST.GET_SIGNATURE,
    payload: { ...payload },
    callBack,
  };
};

export const getSignature_Success = (payload) => ({
  type: CONST.GET_SIGNATURE_SUCCESS,
  payload,
});

export const getSignature_Fail = (payload) => ({
  type: CONST.GET_SIGNATURE_FAIL,
  payload,
});

export const getSignatureById = (payload, callBack) => {
  return {
    type: CONST.GET_SIGNATURE_BY_ID,
    payload: payload,
    callBack,
  };
};

export const getSignatureById_Success = (payload) => ({
  type: CONST.GET_SIGNATURE_BY_ID_SUCCESS,
  payload,
});

export const getSignatureById_Fail = (payload) => ({
  type: CONST.GET_SIGNATURE_BY_ID_FAIL,
  payload,
});

export const updateSignature = (payload, callBack) => {
  return {
    type: CONST.UPDATE_SIGNATURE,
    payload: { ...payload },
    callBack,
  };
};

export const updateSignature_Success = (payload) => ({
  type: CONST.UPDATE_SIGNATURE_SUCCESS,
  payload,
});

export const updateSignature_Fail = (payload) => ({
  type: CONST.UPDATE_SIGNATURE_FAIL,
  payload,
});

export const deleteSignature = (payload, callBack) => {
  return {
    type: CONST.DELETE_SIGNATURE,
    payload: { ...payload },
    callBack,
  };
};

export const deleteSignature_Success = (payload) => ({
  type: CONST.DELETE_SIGNATURE_SUCCESS,
  payload,
});

export const deleteSignature_Fail = (payload) => ({
  type: CONST.DELETE_SIGNATURE_FAIL,
  payload,
});

// ================================================= //

export const getMessageList = (payload, callBack) => {
  return {
    type: CONST.GET_MESSAGE_LIST,
    payload: { ...payload },
    callBack,
  };
};

export const getMessageList_Success = (payload) => ({
  type: CONST.GET_MESSAGE_LIST_SUCCESS,
  payload,
});

export const getMessageList_Fail = (payload) => ({
  type: CONST.GET_MESSAGE_LIST_FAIL,
  payload,
});

// ==================================================== //

export const getMessageById = (payload, callBack) => {
  return {
    type: CONST.GET_MESSAGE_BY_ID,
    payload: payload,
    callBack,
  };
};

export const getMessageById_Success = (payload) => ({
  type: CONST.GET_MESSAGE_BY_ID_SUCCESS,
  payload,
});

export const getMessageById_Fail = (payload) => ({
  type: CONST.GET_MESSAGE_BY_ID_FAIL,
  payload,
});

// ================================================= //

export const getSubscriberList = (payload, callBack) => {
  return {
    type: CONST.GET_SUBSCRIBER_LIST,
    payload: { ...payload },
    callBack,
  };
};

export const getSubscriberList_Success = (payload) => ({
  type: CONST.GET_SUBSCRIBER_LIST_SUCCESS,
  payload,
});

export const getSubscriberList_Fail = (payload) => ({
  type: CONST.GET_SUBSCRIBER_LIST_FAIL,
  payload,
});

// ==================================================== //

export const getSubscriberById = (payload, callBack) => {
  return {
    type: CONST.GET_SUBSCRIBER_BY_ID,
    payload: payload,
    callBack,
  };
};

export const getSubscriberById_Success = (payload) => ({
  type: CONST.GET_SUBSCRIBER_BY_ID_SUCCESS,
  payload,
});

export const getSubscriberById_Fail = (payload) => ({
  type: CONST.GET_SUBSCRIBER_BY_ID_FAIL,
  payload,
});

// ================================================= //

export const getFacebookList = (payload, callBack) => {
  return {
    type: CONST.GET_FACEBOOK_LIST,
    payload: { ...payload },
    callBack,
  };
};

export const getFacebookList_Success = (payload) => ({
  type: CONST.GET_FACEBOOK_LIST_SUCCESS,
  payload,
});

export const getFacebookList_Fail = (payload) => ({
  type: CONST.GET_FACEBOOK_LIST_FAIL,
  payload,
});

// ==================================================== //

export const getFacebookById = (payload, callBack) => {
  return {
    type: CONST.GET_FACEBOOK_BY_ID,
    payload: payload,
    callBack,
  };
};

export const getFacebookById_Success = (payload) => ({
  type: CONST.GET_FACEBOOK_BY_ID_SUCCESS,
  payload,
});

export const getFacebookById_Fail = (payload) => ({
  type: CONST.GET_FACEBOOK_BY_ID_FAIL,
  payload,
});

// ================================================= //

export const getInstagramList = (payload, callBack) => {
  return {
    type: CONST.GET_INSTAGRAM_LIST,
    payload: { ...payload },
    callBack,
  };
};

export const getInstagramList_Success = (payload) => ({
  type: CONST.GET_INSTAGRAM_LIST_SUCCESS,
  payload,
});

export const getInstagramList_Fail = (payload) => ({
  type: CONST.GET_INSTAGRAM_LIST_FAIL,
  payload,
});

// ==================================================== //

export const getInstagramById = (payload, callBack) => {
  return {
    type: CONST.GET_INSTAGRAM_BY_ID,
    payload: payload,
    callBack,
  };
};

export const getInstagramById_Success = (payload) => ({
  type: CONST.GET_INSTAGRAM_BY_ID_SUCCESS,
  payload,
});

export const getInstagramById_Fail = (payload) => ({
  type: CONST.GET_INSTAGRAM_BY_ID_FAIL,
  payload,
});

// ================================================= //

export const getTwitterList = (payload, callBack) => {
  return {
    type: CONST.GET_TWITTER_LIST,
    payload: { ...payload },
    callBack,
  };
};

export const getTwitterList_Success = (payload) => ({
  type: CONST.GET_TWITTER_LIST_SUCCESS,
  payload,
});

export const getTwitterList_Fail = (payload) => ({
  type: CONST.GET_TWITTER_LIST_FAIL,
  payload,
});

// ==================================================== //

export const getTwitterById = (payload, callBack) => {
  return {
    type: CONST.GET_TWITTER_BY_ID,
    payload: payload,
    callBack,
  };
};

export const getTwitterById_Success = (payload) => ({
  type: CONST.GET_TWITTER_BY_ID_SUCCESS,
  payload,
});

export const getTwitterById_Fail = (payload) => ({
  type: CONST.GET_TWITTER_BY_ID_FAIL,
  payload,
});

// ================================================= //

export const getYoutubeList = (payload, callBack) => {
  return {
    type: CONST.GET_YOUTUBE_LIST,
    payload: { ...payload },
    callBack,
  };
};

export const getYoutubeList_Success = (payload) => ({
  type: CONST.GET_YOUTUBE_LIST_SUCCESS,
  payload,
});

export const getYoutubeList_Fail = (payload) => ({
  type: CONST.GET_YOUTUBE_LIST_FAIL,
  payload,
});

// ==================================================== //

export const getYoutubeById = (payload, callBack) => {
  return {
    type: CONST.GET_YOUTUBE_BY_ID,
    payload: payload,
    callBack,
  };
};

export const getYoutubeById_Success = (payload) => ({
  type: CONST.GET_YOUTUBE_BY_ID_SUCCESS,
  payload,
});

export const getYoutubeById_Fail = (payload) => ({
  type: CONST.GET_YOUTUBE_BY_ID_FAIL,
  payload,
});

// ================================================= //

export const getTiktokList = (payload, callBack) => {
  return {
    type: CONST.GET_TIKTOK_LIST,
    payload: { ...payload },
    callBack,
  };
};

export const getTiktokList_Success = (payload) => ({
  type: CONST.GET_TIKTOK_LIST_SUCCESS,
  payload,
});

export const getTiktokList_Fail = (payload) => ({
  type: CONST.GET_TIKTOK_LIST_FAIL,
  payload,
});

// ==================================================== //

export const getTiktokById = (payload, callBack) => {
  return {
    type: CONST.GET_TIKTOK_BY_ID,
    payload: payload,
    callBack,
  };
};

export const getTiktokById_Success = (payload) => ({
  type: CONST.GET_TIKTOK_BY_ID_SUCCESS,
  payload,
});

export const getTiktokById_Fail = (payload) => ({
  type: CONST.GET_TIKTOK_BY_ID_FAIL,
  payload,
});

// ================================================= //

export const getFormList = (payload, callBack) => {
  return {
    type: CONST.GET_FORM_LIST,
    payload: { ...payload },
    callBack,
  };
};

export const getFormList_Success = (payload) => ({
  type: CONST.GET_FORM_LIST_SUCCESS,
  payload,
});

export const getFormList_Fail = (payload) => ({
  type: CONST.GET_FORM_LIST_FAIL,
  payload,
});

// ==================================================== //

export const getFormById = (payload, callBack) => {
  return {
    type: CONST.GET_FORM_BY_ID,
    payload: payload,
    callBack,
  };
};

export const getFormById_Success = (payload) => ({
  type: CONST.GET_FORM_BY_ID_SUCCESS,
  payload,
});

export const getFormById_Fail = (payload) => ({
  type: CONST.GET_FORM_BY_ID_FAIL,
  payload,
});

// ================================================= //

export const getFinanceList = (payload, callBack) => {
  return {
    type: CONST.GET_FINANCE_LIST,
    payload: { ...payload },
    callBack,
  };
};

export const getFinanceList_Success = (payload) => ({
  type: CONST.GET_FINANCE_LIST_SUCCESS,
  payload,
});

export const getFinanceList_Fail = (payload) => ({
  type: CONST.GET_FINANCE_LIST_FAIL,
  payload,
});

// ==================================================== //

export const getFinanceById = (payload, callBack) => {
  return {
    type: CONST.GET_FINANCE_BY_ID,
    payload: payload,
    callBack,
  };
};

export const getFinanceById_Success = (payload) => ({
  type: CONST.GET_FINANCE_BY_ID_SUCCESS,
  payload,
});

export const getFinanceById_Fail = (payload) => ({
  type: CONST.GET_FINANCE_BY_ID_FAIL,
  payload,
});

// ==================================================== //

export const getDetailSettings = (payload, callBack) => {
  return {
    type: CONST.GET_DETAIL_SETTINGS,
    payload: payload,
    callBack,
  };
};

export const getDetailSettings_Success = (payload) => ({
  type: CONST.GET_DETAIL_SETTINGS_SUCCESS,
  payload,
});

export const getDetailSettings_Fail = (payload) => ({
  type: CONST.GET_DETAIL_SETTINGS_FAIL,
  payload,
});

// ==================================================== //

export const updateDetailSettings = (payload, callBack) => {
  return {
    type: CONST.UPDATE_DETAIL_SETTING,
    payload: payload,
    callBack,
  };
};

export const updateDetailSettings_Success = (payload) => ({
  type: CONST.UPDATE_DETAIL_SETTING_SUCCESS,
  payload,
});

export const updateDetailSettings_Fail = (payload) => ({
  type: CONST.UPDATE_DETAIL_SETTING_FAIL,
  payload,
});

// ==================================================== //

export const postFinancial = (payload, userId, callBack) => {
  return {
    type: CONST.POST_FINANCIAL,
    payload: { ...payload },
    userId,
    callBack,
  };
};

export const postFinancial_Success = (payload) => ({
  type: CONST.POST_FINANCIAL_SUCCESS,
  payload,
});

export const postFinancial_Fail = (payload) => ({
  type: CONST.POST_FINANCIAL_FAIL,
  payload,
});

// ==================================================== //

export const postRole = (payload, callBack) => {
  return {
    type: CONST.POST_ROLE,
    payload: { ...payload },
    callBack,
  };
};

export const postRole_Success = (payload) => ({
  type: CONST.POST_ROLE_SUCCESS,
  payload,
});

export const postRole_Fail = (payload) => ({
  type: CONST.POST_ROLE_FAIL,
  payload,
});

export const getRoleList = (payload, callBack) => {
  return {
    type: CONST.GET_ROLE_LIST,
    payload: { ...payload },
    callBack,
  };
};

export const getRoleList_Success = (payload) => ({
  type: CONST.GET_ROLE_LIST_SUCCESS,
  payload,
});

export const getRoleList_Fail = (payload) => ({
  type: CONST.GET_ROLE_LIST_FAIL,
  payload,
});

export const getRoleById = (payload, callBack) => {
  return {
    type: CONST.GET_ROLE_BY_ID,
    payload: payload,
    callBack,
  };
};

export const getRoleById_Success = (payload) => ({
  type: CONST.GET_ROLE_BY_ID_SUCCESS,
  payload,
});

export const getRoleById_Fail = (payload) => ({
  type: CONST.GET_ROLE_BY_ID_FAIL,
  payload,
});

export const updateRole = (payload, callBack) => {
  return {
    type: CONST.UPDATE_ROLE,
    payload: { ...payload },
    callBack,
  };
};

export const updateRole_Success = (payload) => ({
  type: CONST.UPDATE_ROLE_SUCCESS,
  payload,
});

export const updateRole_Fail = (payload) => ({
  type: CONST.UPDATE_ROLE_FAIL,
  payload,
});

export const deleteRole = (payload, callBack) => {
  return {
    type: CONST.DELETE_ROLE,
    payload: payload,
    callBack,
  };
};

export const deleteRole_Success = (payload) => ({
  type: CONST.DELETE_ROLE_SUCCESS,
  payload,
});

export const deleteRole_Fail = (payload) => ({
  type: CONST.DELETE_ROLE_FAIL,
  payload,
});

// ==================================================== //

export const postSubadmin = (payload, callBack) => {
  return {
    type: CONST.POST_SUBADMIN,
    payload: { ...payload },
    callBack,
  };
};

export const postSubadmin_Success = (payload) => ({
  type: CONST.POST_SUBADMIN_SUCCESS,
  payload,
});

export const postSubadmin_Fail = (payload) => ({
  type: CONST.POST_SUBADMIN_FAIL,
  payload,
});

export const getSubadminList = (payload, callBack) => {
  return {
    type: CONST.GET_SUBADMIN_LIST,
    payload: { ...payload },
    callBack,
  };
};

export const getSubadminList_Success = (payload) => ({
  type: CONST.GET_SUBADMIN_LIST_SUCCESS,
  payload,
});

export const getSubadminList_Fail = (payload) => ({
  type: CONST.GET_SUBADMIN_LIST_FAIL,
  payload,
});

export const getSubadminById = (payload, callBack) => {
  return {
    type: CONST.GET_SUBADMIN_BY_ID,
    payload: payload,
    callBack,
  };
};

export const getSubadminById_Success = (payload) => ({
  type: CONST.GET_SUBADMIN_BY_ID_SUCCESS,
  payload,
});

export const getSubadminById_Fail = (payload) => ({
  type: CONST.GET_SUBADMIN_BY_ID_FAIL,
  payload,
});

export const updateSubadmin = (payload, callBack) => {
  return {
    type: CONST.UPDATE_SUBADMIN,
    payload: { ...payload },
    callBack,
  };
};

export const updateSubadmin_Success = (payload) => ({
  type: CONST.UPDATE_SUBADMIN_SUCCESS,
  payload,
});

export const updateSubadmin_Fail = (payload) => ({
  type: CONST.UPDATE_SUBADMIN_FAIL,
  payload,
});

export const deleteSubadmin = (payload, callBack) => {
  return {
    type: CONST.DELETE_SUBADMIN,
    payload: payload,
    callBack,
  };
};

export const deleteSubadmin_Success = (payload) => ({
  type: CONST.DELETE_SUBADMIN_SUCCESS,
  payload,
});

export const deleteSubadmin_Fail = (payload) => ({
  type: CONST.DELETE_SUBADMIN_FAIL,
  payload,
});

export const resetSubadminPass = (payload, callBack) => {
  return {
    type: CONST.RESET_SUBADMIN_PASS,
    payload: payload,
    callBack,
  };
};

export const resetSubadminPass_Success = (payload) => ({
  type: CONST.RESET_SUBADMIN_PASS_SUCCESS,
  payload,
});

export const resetSubadminPass_Fail = (payload) => ({
  type: CONST.RESET_SUBADMIN_PASS_FAIL,
  payload,
});

export const dropdownSubadmin = (payload, callBack) => {
  return {
    type: CONST.DROPDOWN_SUBADMIN,
    payload: payload,
    callBack,
  };
};

export const dropdownSubadmin_Success = (payload) => ({
  type: CONST.DROPDOWN_SUBADMIN_SUCCESS,
  payload,
});

export const dropdownSubadmin_Fail = (payload) => ({
  type: CONST.DROPDOWN_SUBADMIN_FAIL,
  payload,
});

// ================= ROLE END ================== //

export const adminDetail = (payload, callBack) => {
  return {
    type: CONST.ADMIN_DETAIL,
    payload: payload,
    callBack,
  };
};

export const adminDetail_Success = (payload) => ({
  type: CONST.ADMIN_DETAIL_SUCCESS,
  payload,
});

export const adminDetail_Fail = (payload) => ({
  type: CONST.ADMIN_DETAIL_FAIL,
  payload,
});

export const rowSorting = (payload, callBack) => {
  return {
    type: CONST.ROW_SORTING,
    payload: payload,
    callBack,
  };
};

export const rowSorting_Success = (payload) => ({
  type: CONST.ROW_SORTING_SUCCESS,
  payload,
});

export const rowSorting_Fail = (payload) => ({
  type: CONST.ROW_SORTING_FAIL,
  payload,
});

export const postConfigure = (payload, callBack) => {
  return {
    type: CONST.POST_CONFIGURE,
    payload: payload,
    callBack,
  };
};

export const postConfigure_Success = (payload) => ({
  type: CONST.POST_CONFIGURE_SUCCESS,
  payload,
});

export const postConfigure_Fail = (payload) => ({
  type: CONST.POST_CONFIGURE_FAIL,
  payload,
});

export const getConfigure = (payload, callBack) => {
  return {
    type: CONST.GET_CONFIGURE,
    payload: payload,
    callBack,
  };
};

export const getConfigure_Success = (payload) => ({
  type: CONST.GET_CONFIGURE_SUCCESS,
  payload,
});

export const getConfigure_Fail = (payload) => ({
  type: CONST.GET_CONFIGURE_FAIL,
  payload,
});

export const getFieldData = (payload, callBack) => {
  return {
    type: CONST.GET_FIELD_DATA,
    payload: payload,
    callBack,
  };
};

export const getFieldData_Success = (payload) => ({
  type: CONST.GET_FIELD_DATA_SUCCESS,
  payload,
});

export const getFieldData_Fail = (payload) => ({
  type: CONST.GET_FIELD_DATA_FAIL,
  payload,
});

export const sendEmailSubscriber = (payload, callBack) => {
  return {
    type: CONST.SEND_EMAIL_SUBSCRIBER,
    payload: payload,
    callBack,
  };
};

export const sendEmailSubscriber_Success = (payload) => ({
  type: CONST.SEND_EMAIL_SUBSCRIBER_SUCCESS,
  payload,
});

export const sendEmailSubscriber_Fail = (payload) => ({
  type: CONST.SEND_EMAIL_SUBSCRIBER_FAIL,
  payload,
});

export const sendSmsSubscriber = (payload, callBack) => {
  return {
    type: CONST.SEND_SMS_SUBSCRIBER,
    payload: payload,
    callBack,
  };
};

export const sendSmsSubscriber_Success = (payload) => ({
  type: CONST.SEND_SMS_SUBSCRIBER_SUCCESS,
  payload,
});

export const sendSmsSubscriber_Fail = (payload) => ({
  type: CONST.SEND_SMS_SUBSCRIBER_FAIL,
  payload,
});

export const healthInsuranceList = (payload, callBack) => {
  return {
    type: CONST.HEALTH_INSURANCE_LIST,
    payload: payload,
    callBack,
  };
};

export const healthInsuranceList_Success = (payload) => ({
  type: CONST.HEALTH_INSURANCE_LIST_SUCCESS,
  payload,
});

export const healthInsuranceList_Fail = (payload) => ({
  type: CONST.HEALTH_INSURANCE_LIST_FAIL,
  payload,
});

export const getHealthInsurance = (payload, callBack) => {
  return {
    type: CONST.GET_HEALTH_INSURANCE,
    payload: payload,
    callBack,
  };
};

export const getHealthInsurance_Success = (payload) => ({
  type: CONST.GET_HEALTH_INSURANCE_SUCCESS,
  payload,
});

export const getHealthInsurance_Fail = (payload) => ({
  type: CONST.GET_HEALTH_INSURANCE_FAIL,
  payload,
});

export const convertToIrs = (payload, callBack) => {
  return {
    type: CONST.CONVERT_TO_IRS,
    payload: payload,
    callBack,
  };
};

export const convertToIrs_Success = (payload) => ({
  type: CONST.CONVERT_TO_IRS_SUCCESS,
  payload,
});

export const convertToIrs_Fail = (payload) => ({
  type: CONST.CONVERT_TO_IRS_FAIL,
  payload,
});
